import { Label } from "semantic-ui-react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import bisac from "astrid-config/src/bisac.json";
import thema from "astrid-config/src/genres/thema_v1.6_sv.json";

import MetaSummary from "../../../ui/components/MetaSummary/MetaSummary";
import Popup from "../../../ui/components/Popup/Popup";

import useArticleMetadataValues from "../../../articles/hooks/useArticleMetadataValues";
import useHasRight from "../../../authorization/hooks/useHasRight";

import WorkMetaDataEdit from "../WorkMetaDataEdit/WorkMetaDataEdit";

export default function WorkSummary({ work, publisher, overlay, disableSerie }) {
	const { t } = useTranslation();

	const hasRight = useHasRight();
	const getValues = useArticleMetadataValues();

	const [edit, setEdit] = useState(false);

	const values = getValues(work);

	const createdBy = work.id.includes("biblio") ? "Biblio" : work.createdBy?.email ? work.createdBy.name : "Astrid";

	const left = [
		values.authors,
		values.translators,
		values.narrators,
		values.serie,
		values.originalName,
		values.language,
		values.originalLanguage,
		values.additionalLanguages,
		{ ...values.synopsis, style: { flex: "0 0 100%" } },
	];

	const right = [
		{
			...values.themaCodes,
			value:
				values.themaCodes.value &&
				work.themaCodes.map((code) => (
					<Popup
						key={code}
						position="bottom center"
						content={thema[code] || code}
						trigger={
							<Label
								circular
								size="tiny"
								key={code}
								color={code === work.mainThemaCode ? "blue" : undefined}
							>
								{code}
							</Label>
						}
					/>
				)),
		},
		{
			...values.bisacCodes,
			value:
				values.bisacCodes.value &&
				work.bisacCodes.map((code) => (
					<Popup
						key={code}
						position="bottom center"
						content={bisac[code] || code}
						trigger={
							<Label circular size="tiny" key={code}>
								{code}
							</Label>
						}
					/>
				)),
		},
		values.bokgruppe,
		values.tags,
		values.abridged,
		{
			label: t("created", "Created"),
			value: `${work.created?.toDate().toLocaleDateString()}${work.createdBy?.name ? ` by ${createdBy}` : ""}`,
			style: { flex: "0 0 100%" },
		},
		{
			label: t("updated", "Updated"),
			value: `${work.updated?.toDate().toLocaleDateString()}${
				work.updatedBy?.name ? ` by ${work.updatedBy.name}` : ""
			}`,
			style: { flex: "0 0 100%" },
		},
	];

	return (
		<>
			<MetaSummary onEdit={hasRight("articles.view") && (() => setEdit(true))} left={left} right={right} />

			{edit && (
				<WorkMetaDataEdit
					work={work}
					publisher={publisher}
					overlay={overlay}
					onClose={() => setEdit(false)}
					disableSerie={disableSerie}
				/>
			)}
		</>
	);
}
